import React, { useState, useEffect } from 'react';
import { formatCurrency } from '../../../../../../../../../../utils/functions';
import BillDetails from './components/BillDetails/BillDetails';
import { BillType } from '../../../../../../types';
import './BillItem.scss';
import { FaPen } from 'react-icons/fa';
import ModalEditBillItem from './components/ModalEditBillItem/ModalEditBillItem';

interface BillItemProps {
  icon: React.ReactNode;
  billsList: any;
  setBillsList: (allBills: BillType[]) => void;
  allBills: BillType[];
  showSelection?: boolean;
  selectedCategories?: any[];
  setSelectedCategories?: (selected: any[]) => void;
  isAdminOrSuperAdmin?: boolean;
  handleEditLocalCategory?: (editedCategory: { local_bill_category_id: number; item_name: string; item_description?: string }) => void;
  fetchBills: () => void; // Función para obtener las facturas
}

const BillItem: React.FC<BillItemProps> = ({
  icon,
  billsList,
  setBillsList,
  allBills,
  showSelection = false,
  selectedCategories = [],
  setSelectedCategories,
  isAdminOrSuperAdmin,
  handleEditLocalCategory,
  fetchBills
}) => {
  const [showModal, setShowModal] = useState(false);
  const [filteredBills, setFilteredBills] = useState<BillType[]>([]);
  const [categoryName, setCategoryName] = useState(billsList.name);
  const [categoryDescription, setCategoryDescription] = useState(billsList.description || '');

  useEffect(() => {
    if (billsList.global_bill_category_id) {
      setFilteredBills(
        allBills.filter(
          bill => bill.global_bill_category_id === billsList.global_bill_category_id
        )
      );
    } else if (billsList.local_bill_category_id) {
      setFilteredBills(
        allBills.filter(
          bill => bill.local_bill_category_id === billsList.local_bill_category_id
        )
      );
    }
    // Actualiza el nombre y descripción locales si cambian en la prop
    setCategoryName(billsList.name);
    setCategoryDescription(billsList.description || '');
  }, [billsList, allBills]);

  const averageForThisCategory =
    filteredBills.length > 0
      ? filteredBills.reduce((sum, bill) => sum + bill.amount, 0) / filteredBills.length
      : 0;

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);


  const handleAddBill = (newBill: BillType) => {
    setBillsList([newBill, ...allBills]);
  };

  // Determina si este ítem está seleccionado
  const isSelected = selectedCategories.some(cat => cat.id === billsList.id);

  // Alterna selección en el padre
  const toggleSelect = () => {
    if (!setSelectedCategories) return;
    if (isSelected) {
      setSelectedCategories(selectedCategories.filter(cat => cat.id !== billsList.id));
    } else {
      setSelectedCategories([...selectedCategories, { ...billsList, id: billsList.id }]);
    }
  };

  return (
    <div className="bill-item-container">
      <div
        className={`
          category-button
          ${showSelection ? 'select-mode' : ''}
          ${showSelection && isSelected ? 'selected' : ''}
        `}
        onClick={() => {
          if (showSelection) {
            toggleSelect();
          } else {
            handleOpenModal();
          }
        }}
      >
        <div className="category-icon">{icon}</div>
        <div className="category-details">
          <h3 className="category-name-bills">{categoryName}</h3>
          <p className="category-total">
            {formatCurrency(averageForThisCategory)}
          </p>
          <small className="category-note-bills">
            Promedio por cuenta
          </small>
        </div>
      </div>

      {!showSelection && (
        <>
          <BillDetails
            billsList={{ ...billsList, name: categoryName, description: categoryDescription, bills: filteredBills }}
            setBillsList={(updatedBills: BillType[]) => {
              setBillsList(updatedBills);
            }}
            show={showModal}
            handleClose={handleCloseModal}
            handleAddBill={handleAddBill}
            isAdminOrSuperAdmin={isAdminOrSuperAdmin}
            handleEditLocalCategory={(editedCategory) => {
              setCategoryName(editedCategory.item_name);
              setCategoryDescription(editedCategory.item_description || '');
            }}
          />
        </>
      )}
    </div>
  );
};

export default BillItem;
